"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableHeaderPaginatorBehavior = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("../bc-data-table-constants");
var BcDataTableHeaderPaginatorBehavior = (function () {
    function BcDataTableHeaderPaginatorBehavior(bcDataTableConfig) {
        var _a;
        this.bcDataTableConfig = bcDataTableConfig;
        this.paginatorConfig = (_a = this.bcDataTableConfig.header) === null || _a === void 0 ? void 0 : _a.paginator;
    }
    BcDataTableHeaderPaginatorBehavior.prototype.init = function (divHeaderPaginator) {
        this.setHeaderPaginator(divHeaderPaginator);
    };
    BcDataTableHeaderPaginatorBehavior.prototype.setHeaderPaginator = function (divHeaderSettings) {
        this.initConfig();
        var paginator = this.createPaginatorNav(this.paginatorConfig);
        divHeaderSettings.appendChild(paginator);
        return divHeaderSettings;
    };
    BcDataTableHeaderPaginatorBehavior.prototype.getPaginatedArray = function (dataSetDataTable) {
        var _a;
        if ((_a = this.bcDataTableConfig.header) === null || _a === void 0 ? void 0 : _a.paginator) {
            this.paginatorConfig = this.bcDataTableConfig.header.paginator;
            var indiceInicio = (this.paginatorConfig.initialPage - 1) * this.paginatorConfig.itemsPerPage;
            var indiceFin = Math.min(indiceInicio + this.paginatorConfig.itemsPerPage, this.bcDataTableConfig.data.length);
            return dataSetDataTable.slice(indiceInicio, indiceFin);
        }
        return dataSetDataTable;
    };
    BcDataTableHeaderPaginatorBehavior.prototype.initConfig = function () {
        var _a, _b;
        this.paginatorConfig.type = this.paginatorConfig.type || 'numeric';
        this.paginatorConfig.totalItems = this.bcDataTableConfig.data.length;
        this.paginatorConfig.initialPage = this.paginatorConfig.initialPage || bc_data_table_constants_1.BcDataTableConstansts.PAGINATOR_DEFAULT_INITIAL_PAGE;
        this.paginatorConfig.itemsPerPage = this.paginatorConfig.itemsPerPage || bc_data_table_constants_1.BcDataTableConstansts.PAGINATOR_DEFAULT_ITEMS_PER_PAGE;
        this.paginatorConfig.pageSizeOptions = this.paginatorConfig.pageSizeOptions || bc_data_table_constants_1.BcDataTableConstansts.PAGINATOR_DEFAULT_PAGE_SIZE_OPTIONS;
        this.paginatorConfig.showPageSize = (_a = this.paginatorConfig.showPageSize) !== null && _a !== void 0 ? _a : true;
        this.paginatorConfig.showInfoItems = (_b = this.paginatorConfig.showInfoItems) !== null && _b !== void 0 ? _b : true;
        this.paginatorConfig.customTextInfoItems = this.paginatorConfig.customTextInfoItems || 'items';
        this.paginatorConfig.classToSync = 'paginator-class-' + this.generateRandomIdNumber();
    };
    BcDataTableHeaderPaginatorBehavior.prototype.createPaginatorNav = function (paginatorConfig) {
        var paginatorNav = document.createElement(common_constants_1.BcCommonConstants.NAV_TAG);
        paginatorNav.id = paginatorConfig.id;
        paginatorNav.setAttribute('type', paginatorConfig.type);
        paginatorNav.setAttribute('totalItems', String(paginatorConfig.totalItems));
        paginatorNav.setAttribute('initialPage', String(paginatorConfig.initialPage));
        paginatorNav.setAttribute('itemsPerPage', String(paginatorConfig.itemsPerPage));
        paginatorNav.setAttribute('showPageSize', String(paginatorConfig.showPageSize));
        paginatorNav.setAttribute('pageSizeOptions', String(paginatorConfig.pageSizeOptions));
        paginatorNav.setAttribute('showInfoItems', String(paginatorConfig.showInfoItems));
        paginatorNav.setAttribute('customTextInfoItems', paginatorConfig.customTextInfoItems);
        paginatorNav.setAttribute('classToSync', paginatorConfig.classToSync);
        return paginatorNav;
    };
    BcDataTableHeaderPaginatorBehavior.prototype.generateRandomIdNumber = function () {
        return window.crypto.getRandomValues(new Uint32Array(1))[0];
    };
    return BcDataTableHeaderPaginatorBehavior;
}());
exports.BcDataTableHeaderPaginatorBehavior = BcDataTableHeaderPaginatorBehavior;
